<template>
  <div class="bubble-wrapper">
    <div class="ivu-card ivu-shadow ivu-card-bordered bubble tri-right round border left-top">
      <div class="content">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    console.log('test')
  }
}
</script>

<style>

.bubble-wrapper {
  display: inline-block;
  width: auto;
  padding-left: 16px;
}

.bubble {
  display: inline-block;
  position: relative;
	height: auto;
  width: 100%;
  background-color: #fff;
  box-shadow: unset !important;
}

.round{
  border-radius: 4px;
	-webkit-border-radius: 4px;
	-moz-border-radius: 4px;
}

.bubble .content{
  padding: 1em;
	text-align: left;
  line-height: 1.5em;
}


/* Right triangle placed top left flush. */
.tri-right.border.left-top:before {
	content: ' ';
	position: absolute;
	width: 0;
	height: 0;
  left: -14px;
	right: auto;
  top: -1px;
	bottom: auto;
	border: 16px solid;
	border-color: transparent transparent transparent transparent;
}
.tri-right.left-top:after{
	content: ' ';
	position: absolute;
	width: 0;
	height: 0;
  left: -16px;
	right: auto;
  top: 0px;
	bottom: auto;
	border: 16px solid;
	border-color: #fff transparent transparent transparent;
}
</style>
